<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="color + '  fill-current ' + size "
    viewBox="0 0 20 20"
    height="14"
    width="14"
  >
    <path d="M0,10a10,10 0 1,0 20,0a10,10 0 1,0 -20,0"/>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      required: false,
      type: String,
      default: "size-16"
    },
    color: {
      required: true,
      type: String,
      default: "text-gray-800"
    }
  }
};
</script>